import { type ReactElement } from 'react'

import { type BasePageProps } from '@lib/mixins/with-services'

import { IS_BROWSER } from '@constants/globals'

import { useBrowserService } from '../hooks'
import {
  configureLoggerAndConsoleOnClient,
  configureLoggerAndConsoleOnServer,
} from '../tracking/felog/telemetry'
import { feMetrics } from '../tracking/metrics/femetrics'

const rootLoggerName = 'superfunnel'

export function withTelemetry<T extends BasePageProps>(
  Component: (props: T) => ReactElement,
): (props: T) => ReactElement {
  if (!IS_BROWSER) {
    configureLoggerAndConsoleOnServer(rootLoggerName)
    feMetrics.initOnServer()
  }

  return pageProps => {
    const browserService = useBrowserService()
    if (IS_BROWSER) {
      configureLoggerAndConsoleOnClient(rootLoggerName)
      feMetrics.initOnClient(browserService)
    }

    return <Component {...(pageProps as T)} />
  }
}
